export default __webpack_public_path__ + "static/img_2-175f1887e2d889f0dab3afa570fe3207.png";